<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button>
  <a class="navbar-brand" href="#"></a>
  <button class="navbar-toggler d-md-down-none mr-auto" type="button" appSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button>
 <!--  <div class="container">
    <div class="row">
      <div class="col">
        <div *ngIf="checkLogIn()">
          <small><i class="fas fa-user"></i>{{'     ' + user.data.user.nome.toLowerCase()}}</small>
        </div>
      </div>
      <div class="col">
        <small>{{'Provided by - AZ Tecnologia'}} </small>
      </div>
    </div>
  </div> -->
</header>
